import "./header.css";

import React from "react";
import { Link, useLocation } from "react-router-dom";

import { NAV_LINKS, ROUTES } from "../../data/content";

//Cream bar with the logo and MENU, which opens the full-screen green menu (as on Wix, on all screen sizes)
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { pathname } = useLocation();
  const toggleRef = React.useRef(null);
  const closeRef = React.useRef(null);
  const menuRef = React.useRef(null);

  //Close the menu after navigating
  React.useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  React.useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }
    //Stop the page behind scrolling, and move focus into the menu
    document.body.style.overflow = "hidden";
    closeRef.current.focus();

    const toggle = toggleRef.current;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsMenuOpen(false);
        return;
      }
      //Keep Tab inside the menu while it's open
      if (e.key === "Tab") {
        const focusable = menuRef.current.querySelectorAll("a, button");
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
      toggle.focus({ preventScroll: true });
    };
  }, [isMenuOpen]);

  return (
    <header className={"site-header"}>
      <div className={"site-header-inner"}>
        <Link
          to={ROUTES.HOME}
          className={"site-logo"}
          aria-label={"Salgado's Quality Foods - home"}
        >
          <img
            src={"/images/logo.webp"}
            alt={""}
            width={800}
            height={428}
          />
        </Link>

        <button
          ref={toggleRef}
          type={"button"}
          className={"menu-toggle"}
          aria-expanded={isMenuOpen}
          aria-controls={"site-menu"}
          onClick={() => setIsMenuOpen(true)}
        >
          MENU
        </button>
      </div>

      <div
        ref={menuRef}
        id={"site-menu"}
        className={`site-menu ${isMenuOpen ? "is-open" : ""}`}
        role={"dialog"}
        aria-modal={"true"}
        aria-label={"Menu"}
        hidden={!isMenuOpen}
      >
        <button
          ref={closeRef}
          type={"button"}
          className={"menu-close"}
          onClick={() => setIsMenuOpen(false)}
        >
          Close
        </button>
        <nav aria-label={"Main"}>
          <ul className={"site-menu-list"}>
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`site-menu-link ${pathname === link.path ? "is-active" : ""}`}
                  aria-current={pathname === link.path ? "page" : undefined}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <img
                    src={link.icon}
                    alt={""}
                    className={"site-menu-icon"}
                    width={80}
                    height={80}
                  />
                  <span>{link.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
